/* One seam between the app and wherever jobs live.
   Phase 1: this browser. Phase 2: point API_BASE at the server and nothing
   else in the app changes. Keep the shape (array of job objects) identical. */

const KEY = "pylon:jobs";
const API_BASE = import.meta.env.VITE_API_BASE || "";   // "" = local only

export async function load() {
  if (API_BASE) {
    const res = await fetch(`${API_BASE}/jobs`, { credentials: "include" });
    if (!res.ok) throw new Error(`load failed: ${res.status}`);
    return res.json();
  }
  const raw = localStorage.getItem(KEY);
  return raw ? JSON.parse(raw) : null;
}

export async function save(jobs) {
  if (API_BASE) {
    const res = await fetch(`${API_BASE}/jobs`, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(jobs),
    });
    if (!res.ok) throw new Error(`save failed: ${res.status}`);
    return;
  }
  localStorage.setItem(KEY, JSON.stringify(jobs));
}
